import { useMutation } from 'react-query';

import { SmsMfaEnable } from '../../lib/api';

export function useMutateEnableSmsMfa() {
  return useMutation(SmsMfaEnable);
}
